import { render, staticRenderFns } from "./wxconfig.vue?vue&type=template&id=27895caf&scoped=true"
import script from "./wxconfig.vue?vue&type=script&lang=js"
export * from "./wxconfig.vue?vue&type=script&lang=js"
import style0 from "./wxconfig.vue?vue&type=style&index=0&id=27895caf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27895caf",
  null
  
)

export default component.exports